import { SET_ALL_PRINT_MENU_ITEMS } from "./actionTypes";

export const setAllPrintMenuItemsAction = (items: Array<any>) => {
    return {
        type: SET_ALL_PRINT_MENU_ITEMS,
        payload: items
    };
};
